import type { SaveFileDTO } from 'src/api/models';
import { postAddFileToTicket } from 'src/api/queries/order-portal-bff';
import { ref } from 'vue';


interface UploadResult {
  onSuccess: (callback: () => void) => void;
  onError: (callback: (error: unknown) => void) => void;
}
export function convertFileToBase64 (file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result.split(',')[1]);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = reject;
  });
}

export function useFileUpload () {
  const isUploading = ref(false);

  async function uploadFilesToTicket (ticketId: string, files: File[]): Promise<string[]> {
    isUploading.value = true;

    const fileContents = await Promise.all(files.map(convertFileToBase64));
    const saveFileDTO: SaveFileDTO = { files: fileContents };

    const response = await postAddFileToTicket(ticketId, saveFileDTO);

    return response;
  }

  return {
    isUploading,
    uploadFilesToTicket,
  };
}
